require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./work-sunbury-shores.json") })
        }
      }, "path---work-sunbury-shores");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---work-sunbury-shores!./.cache/json/work-sunbury-shores.json
// module id = 903
// module chunks = 231608221292675